import React, { Component } from "react";
import { toast } from "react-toastify";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import DatePicker from "react-datepicker";
import LoadingOverlay from "./LoadingOverlay";
import "react-datepicker/dist/react-datepicker.css";
import {
  Button,
  Container,
  Row,
  Form,
  Col,
  Offcanvas,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import "./Leaverequestapprovals.css";

export default class Leaverequestapprovals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      lCRshow: false,
      lCAshow: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      uName: sessionStorage.getItem("userName"),
      errors: {},
      minDate: new Date(),
      todayDay: new Date().toLocaleDateString("en-US", { weekday: "long" }),
      time: new Date().toLocaleTimeString(),
      startDate: new Date(),
      filteredData: null,
      currentDate: new Date().toLocaleDateString("en-GB"),
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.leaverequestapprovals_Id,
          sortable: true,
          cell: (row) => <span>{row.leaverequestapprovals_Id}</span>,
        },
        {
          name: "From Date",
          selector: (row, i) => row.FromDate,
          sortable: true,
          cell: (row) => <span>{window.formatDate(row.FromDate)}</span>,
        },
        {
          name: "To Date",
          selector: (row, i) => row.ToDate,
          sortable: true,
          cell: (row) => <span>{window.formatDate(row.ToDate)}</span>,
        },
        {
          name: "Days",
          selector: (row, i) => row.NoOfLeaves,
          sortable: true,
          cell: (row) => (
            <span>
              {row.NoOfLeaves}
              {row.lopDays > 0 && (
                <small style={{ color: "#dc3545", display: "block" }}>
                  ({row.lopDays} LOP)
                </small>
              )}
            </span>
          ),
        },
        {
          name: "Record Type",
          selector: (row, i) => row.recordType,
          sortable: true,
          cell: (row) => (
            <span
              style={{
                fontSize: "11px",
                padding: "2px 6px",
                borderRadius: "3px",
                backgroundColor:
                  row.recordType === "cancellation" ? "#fff3cd" : "#d1ecf1",
                color:
                  row.recordType === "cancellation" ? "#856404" : "#0c5460",
              }}
            >
              {row.recordType === "cancellation" ? "Cancellation" : "Leave"}
            </span>
          ),
        },
        {
          name: "Leave Type",
          selector: (row, i) => row.LeaveType,
          sortable: true,
          cell: (row) => <span>{row.LeaveType}</span>,
        },
        {
          name: "Approved By",
          selector: (row, i) => row.approverName,
          sortable: true,
          cell: (row) => <span>{row.approverName}</span>,
        },
        {
          name: "Status",
          selector: (row, i) => row.status,
          sortable: true,
          cell: (row) => {
            const statusMap = {
              1: {
                label: row.Decision || "Pending",
                color: "#ffc107",
                bg: "#fff3cd",
              },
              2: { label: "Approved", color: "#28a745", bg: "#d4edda" },
              3: { label: "Rejected", color: "#dc3545", bg: "#f8d7da" },
              4: { label: "Withdrawn", color: "#6c757d", bg: "#e2e3e5" },
              5: { label: "Cancel Requested", color: "#fd7e14", bg: "#fff3cd" },
              6: { label: "Cancel Approved", color: "#17a2b8", bg: "#d1ecf1" },
              7: { label: "Cancel Rejected", color: "#dc3545", bg: "#f8d7da" },
            };
            const s = statusMap[row.status] || {
              label: row.Decision || "Unknown",
              color: "#333",
              bg: "#fff",
            };
            return (
              <span
                style={{
                  color: s.color,
                  backgroundColor: s.bg,
                  padding: "2px 8px",
                  borderRadius: "4px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {s.label}
              </span>
            );
          },
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => {
            // eslint-disable-next-line
            if (row.status == 1) {
              return (
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => this.handleWithdraw(row)}
                  disabled={this.state.isWithdrawing}
                  title="Withdraw this leave request"
                >
                  {this.state.isWithdrawing ? "Withdrawing..." : "Withdraw"}
                </Button>
              );
            }
            return null;
          },
        },
      ],
      currentPage: 1,
      itemsPerPage: 40,
      RequestedBy: "",
      LeaveBalance: "",
      FromDate: null,
      //FromDate: this.getCurrentDate(),
      ToDate: null,
      NoOfLeaves: 0,
      leavetypes: [],
      Holidays: [],
      attendanceLeaveDates: [],
      CarryForwardLeaves: "",
      Creditleaves: "",
      TotalLeaves: "",
      UsedLeaves: "",
      LosofpayLeaves: "",
      CompoffLeaves: 0,
      LeaveType: "",
      remarks: "",
      leaverequestapprovals_Id: "",
      lcdetails: "",
      isEditing: false,
      isNewEntry: false,
      compensatoryDate: null,
      usedCompensatoryDates: [],
      cancelDates: [],
      leaverequest: "",
      fName: "",
      leaves: "",
      approverName: "",
      Decision: "",
      cancellationReason: "",
      isSubmitting: false,
      isCancelRequesting: false,
      isUpdating: false,
      isWithdrawing: false,
    };
  }
  //edit
  handleEnterEditMode = (row) => {
    // this.setState({ cData: { ...row }, isEditing: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    this.setState({
      uName: row.uName,
      LeaveBalance: row.LeaveBalance,
      FromDate: row.FromDate,
      ToDate: row.ToDate,
      NoOfLeaves: row.NoOfLeaves,
      LeaveType: row.LeaveType,
      remarks: row.remarks,
      leaverequestapprovals_Id: row.leaverequestapprovals_Id,
      isEditing: true,
    });
  };
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ show: true });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false });
  };

  // Leave Cancel Request offcanvas Open
  LeaveCancelRequesthandleOffcanvasShow = () => {
    this.setState({ lCRshow: true });
  };

  // Leave Cancel Request Offcanvas close button
  LeaveCancelRequesthandleOffcanvasClose = () => {
    this.setState({ lCRshow: false });
  };

  // Leave Cancel Approval offcanvas Open
  LeaveCancelApprovalhandleOffcanvasShow = () => {
    this.setState({ lCAshow: true });
  };

  LeaveCancelApprovalhandleOffcanvasClose = () => {
    this.setState({ lCAshow: false });
  };

  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  LeaverequestapprovalseditHandler = (e) => {
    e.preventDefault();
  };

  LeaverequestapprovalsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Leaverequestapprovals/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState(
            {
              data: data.list.sort(
                (a, b) =>
                  Number(b.leaverequestapprovals_Id) -
                  Number(a.leaverequestapprovals_Id),
              ),
            },
            () => {
              this.updateUsedCompensatoryDates();
            },
          );
        }
      });
  };
  validateForm() {
    let data = this.state;
    let errors = {};
    let formIsValid = true;
    if (!data["FromDate"]) {
      formIsValid = false;
      toast.info("*Please Enter FromDate.");
    } else if (!data["ToDate"]) {
      formIsValid = false;
      toast.info("*Please Enter ToDate.");
    } else if (!data["LeaveType"]) {
      formIsValid = false;
      toast.info("*Please Enter LeaveType.");
    } else if (
      data["LeaveType"] === "Compensatory Leave" &&
      !data["compensatoryDate"]
    ) {
      formIsValid = false;
      toast.info("*Please select the worked date for Compensatory Leave.");
    } else if (
      data["LeaveType"] === "Compensatory Leave" &&
      data["FromDate"] !== data["ToDate"]
    ) {
      formIsValid = false;
      toast.info("Compensatory Leave can only be applied for 1 day.");
    } else if (!data["remarks"]) {
      formIsValid = false;
      toast.info("*Please Enter Remarks.");
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }
  LeaverequestapprovalssubmitHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    //   setButtons(contacts);
    // if (this.validateForm()) {
    // if (this.state.NoOfLeaves <= this.state.LeaveBalance) {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("RequestedBy", this.state.uName);
    formData.append("LeaveBalance", this.state.LeaveBalance);
    formData.append("FromDate", this.state.FromDate);
    formData.append("ToDate", this.state.ToDate);
    formData.append("NoOfLeaves", this.state.NoOfLeaves);
    formData.append("LeaveType", this.state.LeaveType);
    formData.append("remarks", this.state.remarks);
    if (
      this.state.LeaveType === "Compensatory Leave" &&
      this.state.compensatoryDate
    ) {
      formData.append("compensatoryDate", this.state.compensatoryDate);
    }
    formData.append(
      "leaverequestapprovals_Id",
      this.state.leaverequestapprovals_Id,
    );
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Leaverequestapprovals/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.LeaverequestapprovalsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            FromDate: "",
            ToDate: "",
            NoOfLeaves: "",
            LeaveType: "",
            remarks: "",
            DecisionRemarks: "",
            ApproverID: "",
            ApproverType: "",
            leaverequestapprovals_Id: "",
            compensatoryDate: null,
            isSubmitting: false,
          });
        } else {
          this.setState({ isSubmitting: false });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Error submitting leave request:", error);
        this.showToast("Error submitting leave request.", "error");
        this.setState({ isSubmitting: false });
      
        this.setState({ loading: false });});
    //}
    //}
  };
  // D1/D2: Employee requests cancellation of approved leave (goes to manager for approval)
  LeaverequestcancelrequestsubmitHandler = (e) => {
    e.preventDefault();
    if (this.state.isCancelRequesting) return;

    if (!this.state.leaverequestapprovals_Id) {
      this.showToast("Please select a leave to cancel", "error");
      return;
    }
    if (this.state.cancelDates.length === 0) {
      this.showToast("Please select at least one date to cancel", "error");
      return;
    }
    if (
      !this.state.cancellationReason ||
      this.state.cancellationReason.trim() === ""
    ) {
      this.showToast("Please enter cancellation explanation", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append(
      "leaverequestapprovals_Id",
      this.state.leaverequestapprovals_Id,
    );
    formData.append("cancelDates", JSON.stringify(this.state.cancelDates));
    formData.append("cancellationReason", this.state.cancellationReason);

    this.setState({ isCancelRequesting: true });
    fetch(
      configData.api_url + "C_Leaverequestapprovals/requestLeaveCancellation",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.LeaverequestapprovalsfetchHandler();
          this.getleaveBalance();
          this.LeaveCancelRequesthandleOffcanvasClose();
          this.setState({
            FromDate: "",
            ToDate: "",
            NoOfLeaves: "",
            LeaveType: "",
            remarks: "",
            DecisionRemarks: "",
            ApproverID: "",
            ApproverType: "",
            leaverequestapprovals_Id: "",
            lcdetails: "",
            leaverequest: "",
            cancelDates: [],
            cancellationReason: "",
            isCancelRequesting: false,
          });
        } else {
          this.setState({ isCancelRequesting: false });
        }
      })
      .catch((error) => {
        console.error("Error requesting leave cancellation:", error);
        this.showToast("Error requesting leave cancellation.", "error");
        this.setState({ isCancelRequesting: false });
      });
  };
  LeaverequestapprovalsupdateHandler = (e) => {
    e.preventDefault();
    if (this.state.isUpdating) return;
    this.setState({ isUpdating: true });
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("RequestedBy", this.state.uName);
    formData.append("LeaveBalance", this.state.LeaveBalance);
    formData.append("FromDate", this.state.FromDate);
    formData.append("ToDate", this.state.ToDate);
    formData.append("NoOfLeaves", this.state.NoOfLeaves);
    formData.append("LeaveType", this.state.LeaveType);
    formData.append("remarks", this.state.remarks);
    formData.append("DecisionRemarks", this.state.DecisionRemarks);
    formData.append("ApproverID", this.state.ApproverID);
    formData.append("ApproverType", this.state.ApproverType);
    formData.append(
      "leaverequestapprovals_Id",
      this.state.leaverequestapprovals_Id,
    );
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Leaverequestapprovals/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.LeaverequestapprovalsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            uName: "",
            LeaveBalance: "",
            FromDate: "",
            ToDate: "",
            NoOfLeaves: "",
            leavetypes: [],
            LeaveType: "",
            remarks: "",
            isUpdating: false,
          });
        } else {
          this.setState({ isUpdating: false });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Error updating leave request:", error);
        this.showToast("Error updating leave request.", "error");
        this.setState({ isUpdating: false });
      
        this.setState({ loading: false });});
  };
  getleaveBalance = () => {
    // e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("employees_Id", this.state.uId);
    fetch(configData.api_url + "C_Employees/retrive", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            LeaveBalance: data.detail.leaves,
            CarryForwardLeaves: data.detail.cfleaves,
            Creditleaves: data.detail.ycleaves,
            TotalLeaves: data.detail.totleaves,
            UsedLeaves: data.detail.usedleaves,
            LosofpayLeaves: data.detail.lopleaves,
            //CompoffLeaves: data.detail.CompoffLeaves,
          });
        }
      });
  };
  HolidayslistfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Holidayslist/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ Holidays: data.list });
        }
      });
  };
  AttendanceLeavefetchHandler = () => {
    var formData = new FormData();
    const now = new Date();
    const monthParam = `${now.getFullYear()}-${String(
      now.getMonth() + 1,
    ).padStart(2, "0")}`;
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("month", monthParam);
    fetch(configData.api_url + "C_Employees/getattendance", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const leaveList = Array.isArray(data?.list?.leave)
            ? data.list.leave
                .filter(Boolean)
                .map((d) => String(d).split(" ")[0])
            : [];
          this.setState({ attendanceLeaveDates: leaveList });
        }
      });
  };
  componentDidMount() {
    this.LeaverequestapprovalsfetchHandler();
    this.leavetypesfetchHandler();
    this.getleaveBalance();
    this.updateTime();
    this.HolidayslistfetchHandler();
    this.AttendanceLeavefetchHandler();
  }

  updateUsedCompensatoryDates = () => {
    const usedDates = this.state.data
      .filter(
        (lv) =>
          lv.LeaveType === "Compensatory Leave" &&
          (lv.status === "1" || lv.status === "2") &&
          lv.compensatoryDate,
      )
      .map((lv) => lv.compensatoryDate);
    this.setState({ usedCompensatoryDates: usedDates });
  };

  // Generate individual dates from a leave record's FromDate to ToDate
  getLeaveDates = (fromDate, toDate) => {
    const dates = [];
    let cur = new Date(fromDate);
    const end = new Date(toDate);
    while (cur <= end) {
      dates.push(cur.toISOString().split("T")[0]);
      cur.setDate(cur.getDate() + 1);
    }
    return dates;
  };

  // Check if a date can be cancelled (within last 30 days or upcoming)
  isDateCancellable = (dateStr) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    const date = new Date(dateStr);
    date.setHours(0, 0, 0, 0);
    return date >= thirtyDaysAgo;
  };

  // Toggle a date in cancelDates array
  handleCancelDateToggle = (dateStr) => {
    this.setState((prevState) => {
      const exists = prevState.cancelDates.includes(dateStr);
      return {
        cancelDates: exists
          ? prevState.cancelDates.filter((d) => d !== dateStr)
          : [...prevState.cancelDates, dateStr],
      };
    });
  };

  // Select/Deselect all cancellable dates
  handleSelectAllCancelDates = (allCancellableDates) => {
    this.setState((prevState) => {
      const allSelected = allCancellableDates.every((d) =>
        prevState.cancelDates.includes(d),
      );
      return {
        cancelDates: allSelected ? [] : [...allCancellableDates],
      };
    });
  };

  handleCompensatoryDateChange = (date) => {
    if (date) {
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;

      if (this.state.usedCompensatoryDates.includes(formattedDate)) {
        this.showToast(
          "This date has already been used for compensatory leave",
          "error",
        );
        return;
      }
      this.setState({ compensatoryDate: formattedDate });
    }
  };

  updateTime = () => {
    setInterval(() => {
      this.setState({ time: new Date().toLocaleTimeString() });
    }, 1000);
  };
  handleRequestedByChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ RequestedBy: fieldValue });
  };
  handleLeaveBalanceChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ LeaveBalance: fieldValue });
  };
  handlelcdetailsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ lcdetails: fieldValue });
  };
  getCurrentDate() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    // let month = currentDate.getMonth() + 1;
    // let day = currentDate.getDate();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  handleFromDateChange = (date) => {
    if (date) {
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
      if (this.state.LeaveType === "Compensatory Leave") {
        // Compensatory leave is 1 day only — ToDate = FromDate
        this.setState({
          FromDate: formattedDate,
          ToDate: formattedDate,
          NoOfLeaves: 1,
          startDate: new Date(),
        });
      } else {
        this.setState(
          { FromDate: formattedDate, startDate: new Date() },
          this.calculateLeaveBalance,
        );
      }
    }
  };

  // Handle To Date Change
  handleToDateChange = (date) => {
    if (date) {
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
      this.setState(
        { ToDate: formattedDate, startDate: new Date() },
        this.calculateLeaveBalance,
      );
    }
  };
  calculateLeaveBalance = () => {
    const { FromDate, ToDate } = this.state;

    if (!FromDate || !ToDate) {
      return;
    }

    const fromDate = new Date(FromDate);
    const toDate = new Date(ToDate);
    let totalLeaveDays = 0;
    for (
      let date = fromDate;
      date <= toDate;
      date.setDate(date.getDate() + 1)
    ) {
      // console.log(this.isWorkingDay(date))
      // console.log(this.isHoliday(date))
      if (this.isWorkingDay(date) && !this.isHoliday(date)) {
        totalLeaveDays++;
      }
    }
    // console.log(`Total leave days: ${totalLeaveDays}`);
    // console.log(`Total leave days: ${totalLeaveDays}`);
    this.setState({ NoOfLeaves: totalLeaveDays });
  };

  // isWorkingDay = (date) => {
  //   const dayOfWeek = date.getDay();
  //   const lastSaturday = this.getLastSaturdayOfMonth(date);
  //   // const firstSaturday = this.getFirstSaturdayOfMonth(date);
  //   // console.log(firstSaturday);
  //   // const isWorking = dayOfWeek !== 0 && (dayOfWeek !== 6 || date.getDate() === lastSaturday);
  //   const isWorking = dayOfWeek !== 0 && (date.getDate() !== lastSaturday);
  //   // console.log(isWorking);
  //   return isWorking;
  // };
  isWorkingDay = (date) => {
    const dayOfWeek = date.getDay();
    const currentMonth = date.getMonth();
    const currentYear = date.getFullYear();
    // Sunday (0) is non-working
    if (dayOfWeek === 0) return false;
    // Saturday (6) — only last 2 Saturdays are working
    if (dayOfWeek === 6) {
      let saturdays = [];
      // Get all Saturdays in the month
      let tempDate = new Date(currentYear, currentMonth, 1);
      while (tempDate.getMonth() === currentMonth) {
        if (tempDate.getDay() === 6) {
          saturdays.push(tempDate.getDate());
        }
        tempDate.setDate(tempDate.getDate() + 1);
      }
      // Get the last 2 Saturday dates
      const lastTwoSaturdays = saturdays.slice(-2);
      // Only count last 2 Saturdays as working
      return lastTwoSaturdays.includes(date.getDate());
    }
    // Monday to Friday (1–5) are working days
    return true;
  };
  isHoliday = (date) => {
    const formattedDate = date.toISOString().split("T")[0];
    return this.state.Holidays.some(
      (holiday) => holiday.Date === formattedDate,
    );
  };

  getLastSaturdayOfMonth = (date) => {
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const lastSaturday = lastDay.getDate() - ((lastDay.getDay() + 1) % 7);
    return lastSaturday;
  };
  getFirstSaturdayOfMonth = (date) => {
    let date1 = new Date(date.getFullYear(), date.getMonth(), 1); // First day of the month
    while (date1.getDay() !== 6) {
      date1.setDate(date.getDate() + 1);
    }
    return date1.getDay();
  };

  handleNoOfLeavesChange = (e) => {
    const fieldValue = parseInt(e.target.value, 10); // Parse input as integer
    if (!isNaN(fieldValue) && fieldValue >= 0) {
      // If fieldValue is a non-negative number
      this.setState({ NoOfLeaves: fieldValue });
    } else {
      // If fieldValue is negative or NaN, set NoOfLeaves to 0
      this.setState({ NoOfLeaves: 0 });
    }
  };
  handleLeaveTypeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    if (fieldValue === "Compensatory Leave") {
      // Compensatory leave is for 1 day only — auto-set ToDate = FromDate
      this.setState({
        LeaveType: fieldValue,
        ToDate: this.state.FromDate || null,
        NoOfLeaves: this.state.FromDate ? 1 : 0,
      });
    } else {
      this.setState(
        {
          LeaveType: fieldValue,
          compensatoryDate: null,
        },
        this.calculateLeaveBalance,
      );
    }
  };
  leavetypesfetchHandler = () => {
    fetch(configData.api_url + "C_Leavetypes/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ leavetypes: data.list });
        }
      });
  };
  handleDecisionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ remarks: fieldValue });
  };
  handleDecisionRemarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ DecisionRemarks: fieldValue });
  };
  handleApproverIDChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ApproverID: fieldValue });
  };
  handleApproverTypeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ApproverType: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    // implement your edit logic here
  };

  // C1/C2: Withdraw an unapproved leave request (status=1 only)
  handleWithdraw = (row) => {
    if (this.state.isWithdrawing) return;
    if (
      !window.confirm("Are you sure you want to withdraw this leave request?")
    ) {
      return;
    }
    this.setState({ isWithdrawing: true });
    const withdrawToastId = toast.info("Withdrawing leave request...", {
      autoClose: false,
      closeButton: false,
    });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("leaverequestapprovals_Id", row.leaverequestapprovals_Id);
    fetch(configData.api_url + "C_Leaverequestapprovals/withdrawLeaveRequest", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        toast.dismiss(withdrawToastId);
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.LeaverequestapprovalsfetchHandler();
          this.getleaveBalance();
        }
        this.setState({ isWithdrawing: false });
      })
      .catch((error) => {
        toast.dismiss(withdrawToastId);
        console.error("Error withdrawing leave request:", error);
        this.showToast("Error withdrawing leave request.", "error");
        this.setState({ isWithdrawing: false });
      });
  };

  handleDelete = (row, index) => {
    // Redirect to withdraw for backward compatibility
    this.handleWithdraw(row);
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };
  handleBackworkdesk = () => {
    window.location.href = "/workdesk";
  };
  isDateCancelledForLeave = (leaveId, dateString) => {
    if (!leaveId || !dateString) return false;
    const list = Array.isArray(this.state.data) ? this.state.data : [];
    return list.some((record) => {
      if (
        record?.recordType !== "cancellation" ||
        record?.cancellationDecision !== "Approved" ||
        String(record?.parentLeaveId) !== String(leaveId)
      ) {
        return false;
      }
      let dates = [];
      try {
        dates = JSON.parse(record.cancellationDates) || [];
      } catch (e) {
        dates = [];
      }
      return dates.includes(dateString);
    });
  };
  //calnder data
  tileClassName = ({ date }) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dateString = `${year}-${month < 10 ? "0" + month : month}-${
      day < 10 ? "0" + day : day
    }`;

    const isHoliday = this.state.Holidays.some(
      (holiday) => holiday.Date === dateString,
    );

    const isCompensatoryLeave = this.state.data.some(
      (leave) =>
        leave.recordType !== "cancellation" &&
        leave.LeaveType === "Compensatory Leave" &&
        // (leave.status === "1" || leave.status === "2") &&
        leave.Decision === "Approved" &&
        leave.FromDate <= dateString &&
        leave.ToDate >= dateString &&
        !this.isDateCancelledForLeave(
          leave.leaverequestapprovals_Id,
          dateString,
        ),
    );

    const isLeave = (this.state.attendanceLeaveDates || []).includes(
      dateString,
    );
    // ✅ Get ALL Saturdays in this date's month
    const getSaturdaysInMonth = (y, m) => {
      const saturdays = [];
      const daysInMonth = new Date(y, m, 0).getDate(); // m is 1-based
      for (let d = 1; d <= daysInMonth; d++) {
        const dt = new Date(y, m - 1, d);
        if (dt.getDay() === 6) saturdays.push(d);
      }
      return saturdays;
    };
    const isSunday = date.getDay() === 0;
    const isSaturday = date.getDay() === 6;

    if (isSaturday) {
      const saturdays = getSaturdaysInMonth(year, month);
      const totalSaturdays = saturdays.length;
      // First (totalSaturdays - 2) are holidays, last 2 are working
      const holidaySaturdays = saturdays.slice(0, totalSaturdays - 2);
      const isHolidaySaturday = holidaySaturdays.includes(day);

      if (isHolidaySaturday) return "saturday-holiday"; // yellow + off
      // else last 2 saturdays = working, no special color
    }
    if (isSunday) return "sunday-holiday";
    if (isHoliday) return "holiday";
    if (isCompensatoryLeave) return "compensatory-leave";
    if (isLeave) return "leave-dates";
    return null;
  };

  isDateDisabled = ({ date }) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dayOfWeek = date.getDay();
    const dateString = `${year}-${month < 10 ? "0" + month : month}-${
      day < 10 ? "0" + day : day
    }`;
    const holiday = this.state.Holidays.find(
      (holiday) => holiday.Date === dateString,
    );
    // const lastDayOfMonth = new Date(year, month, 0).getDate();
    // const isLastSaturday = dayOfWeek === 6 && day > lastDayOfMonth - 7;

    // if ((dayOfWeek === 6 && !isLastSaturday) || dayOfWeek === 0 || holiday) {
    if (dayOfWeek === 0 || holiday) {
      return true;
    }
    return false;
  };
  // Columns for the Leave Requests table (recordType != cancellation)
  leaveTableColumns = () => [
    {
      name: "S.NO",
      selector: (row) => row.leaverequestapprovals_Id,
      sortable: true,
      cell: (row) => <span>{row.leaverequestapprovals_Id}</span>,
    },
    {
      name: "From Date",
      selector: (row) => row.FromDate,
      sortable: true,
      cell: (row) => <span>{window.formatDate(row.FromDate)}</span>,
    },
    {
      name: "To Date",
      selector: (row) => row.ToDate,
      sortable: true,
      cell: (row) => <span>{window.formatDate(row.ToDate)}</span>,
    },
    {
      name: "Days",
      selector: (row) => row.NoOfLeaves,
      sortable: true,
      cell: (row) => (
        <span>
          {row.NoOfLeaves}
          {row.lopDays > 0 && (
            <small style={{ color: "#dc3545", display: "block" }}>
              ({row.lopDays} LOP)
            </small>
          )}
        </span>
      ),
    },
    {
      name: "Leave Type",
      selector: (row) => row.LeaveType,
      sortable: true,
      cell: (row) => <span>{row.LeaveType}</span>,
    },
    {
      name: "Approved By",
      selector: (row) => row.approverName,
      sortable: true,
      cell: (row) => <span>{row.approverName}</span>,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => {
        const s = {
          1: {
            label: row.Decision || "Pending",
            color: "#ffc107",
            bg: "#fff3cd",
          },
          2: { label: "Approved", color: "#28a745", bg: "#d4edda" },
          3: { label: "Rejected", color: "#dc3545", bg: "#f8d7da" },
          4: { label: "Withdrawn", color: "#6c757d", bg: "#e2e3e5" },
        }[row.status] || {
          label: row.Decision || "Unknown",
          color: "#333",
          bg: "#fff",
        };
        return (
          <span
            style={{
              color: s.color,
              backgroundColor: s.bg,
              padding: "2px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "bold",
            }}
          >
            {s.label}
          </span>
        );
      },
    },
    {
      name: "Actions",
      sortable: false,
      cell: (row) => {
        // eslint-disable-next-line
        if (row.status == 1) {
          return (
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => this.handleWithdraw(row)}
              disabled={this.state.isWithdrawing}
              title="Withdraw this leave request"
            >
              {this.state.isWithdrawing ? "Withdrawing..." : "Withdraw"}
            </Button>
          );
        }
        return null;
      },
    },
  ];

  // Columns for the Leave Cancellation Requests table (recordType == cancellation)
  cancellationTableColumns = () => [
    {
      name: "S.NO",
      selector: (row) => row.leaverequestapprovals_Id,
      sortable: true,
      cell: (row) => <span>{row.leaverequestapprovals_Id}</span>,
    },
    {
      name: "Linked Leave ID",
      selector: (row) => row.parentLeaveId,
      sortable: true,
      cell: (row) => <span>#{row.parentLeaveId || "-"}</span>,
    },
    {
      name: "Cancel Dates",
      cell: (row) => {
        try {
          const dates = JSON.parse(row.cancellationDates || "[]");
          return (
            <span style={{ fontSize: "11px" }}>
              {dates.map((d) => window.formatDate(d)).join(", ")}
            </span>
          );
        } catch (e) {
          return <span>-</span>;
        }
      },
    },
    {
      name: "Days Cancelled",
      selector: (row) => row.NoOfLeaves,
      sortable: true,
      cell: (row) => <span>{row.NoOfLeaves}</span>,
    },
    {
      name: "Leave Type",
      selector: (row) => row.LeaveType,
      sortable: true,
      cell: (row) => <span>{row.LeaveType}</span>,
    },
    {
      name: "Reason",
      selector: (row) => row.cancellationReason,
      cell: (row) => (
        <span title={row.cancellationReason} style={{ fontSize: "11px" }}>
          {row.cancellationReason
            ? row.cancellationReason.length > 30
              ? row.cancellationReason.substring(0, 30) + "..."
              : row.cancellationReason
            : "-"}
        </span>
      ),
    },
    {
      name: "Cancellation Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => {
        const s = {
          5: { label: "Pending Approval", color: "#fd7e14", bg: "#fff3cd" },
          6: { label: "Cancel Approved", color: "#17a2b8", bg: "#d1ecf1" },
          7: { label: "Cancel Rejected", color: "#dc3545", bg: "#f8d7da" },
        }[row.status] || {
          label: row.Decision || "Unknown",
          color: "#333",
          bg: "#fff",
        };
        return (
          <span
            style={{
              color: s.color,
              backgroundColor: s.bg,
              padding: "2px 8px",
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "bold",
            }}
          >
            {s.label}
          </span>
        );
      },
    },
  ];

  render() {
    // Split data: leave rows (no recordType or recordType='leave') vs cancellation rows
    const sourceData = this.state.filteredData || this.state.data;
    const leaveRows = sourceData.filter(
      (r) => !r.recordType || r.recordType !== "cancellation",
    );
    const cancellationRows = sourceData.filter(
      (r) => r.recordType === "cancellation",
    );

    const paginatedData = leaveRows.slice(
      (this.state.currentPage - 1) * this.state.itemsPerPage,
      this.state.currentPage * this.state.itemsPerPage,
    );
    const paginatedCancellations = cancellationRows.slice(
      (this.state.currentPage - 1) * this.state.itemsPerPage,
      this.state.currentPage * this.state.itemsPerPage,
    );
    const uName = sessionStorage.getItem("userName");
    const previousYearStart = new Date();
    previousYearStart.setFullYear(previousYearStart.getFullYear() - 100);
    previousYearStart.setMonth(0); // Set the month to January
    previousYearStart.setDate(1);
    const minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 1);
    return (
      <div>
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <Row className="mb-3">
          <div className="col-md-12 mb-3">
            <div className="widget_BG d-flex align-items-center">
              {/* <h3 className="">Leave Detail - {uName}</h3> */}
              <h3 className="align-middle">Leave Managing Page</h3>
            </div>
          </div>
          {/* <div className="col-md-4 text-center">
            <div className="widget_BG">
              <Button
                variant="primary border_radius"
                onClick={this.LeaveCancelRequesthandleOffcanvasShow}                
                style={{ marginRight: "10px"}}
              >
                Leave Cancel Request
              </Button>              
              &nbsp;
              <Button
                variant="primary border_radius"                
                onClick={this.handleBackworkdesk} 
              >
                Leave Cancel Approval
              </Button>
            </div>
          </div> */}
          <div className="col-md-4">
            <div className="widget_BG widget_BG_grid">
              <h4>
                {this.state.currentDate} {this.state.time} {this.state.todayDay}
              </h4>
            </div>
          </div>

          <div className="col-md-8 text-center">
            <div className="widget_BG">
              <Button
                variant="primary border_radius"
                onClick={this.handleOffcanvasShow}
              >
                New Leave Request
              </Button>
              &nbsp;
              <Button
                variant="primary border_radius"
                onClick={this.LeaveCancelRequesthandleOffcanvasShow}
                style={{ margin: "0px 10px" }}
              >
                Leave cancellation Request
              </Button>
              &nbsp;
              <Button
                variant="primary border_radius"
                onClick={this.handleBackworkdesk}
              >
                Leave Request Approval
              </Button>
            </div>
          </div>
        </Row>
        <div className="row">
          <Col lg="4" md="4">
            <Calendar
              onChange={this.handleDateChange}
              value={this.state.markAttendanceDate}
              tileClassName={this.tileClassName}
              tileDisabled={this.isDateDisabled}
              tileContent={({ date, view }) => {
                if (view === "month") {
                  const year = date.getFullYear();
                  const month = date.getMonth() + 1;
                  const day = date.getDate();
                  const dateString = `${year}-${
                    month < 10 ? "0" + month : month
                  }-${day < 10 ? "0" + day : day}`;
                  const holiday = this.state.Holidays.find(
                    (holiday) => holiday.Date === dateString,
                  );
                  // find compensatory leave first (approved only)
                  const compensatoryLeave = this.state.data.find(
                    (leave) =>
                      leave.recordType !== "cancellation" &&
                      leave.LeaveType === "Compensatory Leave" &&
                      leave.Decision === "Approved" &&
                      leave.FromDate <= dateString &&
                      leave.ToDate >= dateString &&
                      !this.isDateCancelledForLeave(
                        leave.leaverequestapprovals_Id,
                        dateString,
                      ),
                  );
                  // find regular leave (approved only)
                  const leave = this.state.data.find(
                    (leave) =>
                      leave.recordType !== "cancellation" &&
                      leave.Decision === "Approved" &&
                      leave.FromDate <= dateString &&
                      leave.ToDate >= dateString &&
                      !this.isDateCancelledForLeave(
                        leave.leaverequestapprovals_Id,
                        dateString,
                      ),
                  );
                  if (holiday) {
                    return (
                      <OverlayTrigger
                        overlay={
                          <Tooltip id="tooltip">{holiday.Festival}</Tooltip>
                        }
                      >
                        <span className="d-inline-block holiday-tooltip">
                          {day}
                        </span>
                      </OverlayTrigger>
                    );
                  } else if (compensatoryLeave) {
                    return (
                      <OverlayTrigger
                        overlay={
                          <Tooltip id="tooltip">
                            Compensatory Leave has been taken
                          </Tooltip>
                        }
                      >
                        <span className="d-inline-block compensatory-tooltip">
                          {day}
                        </span>
                      </OverlayTrigger>
                    );
                  } else if (leave) {
                    return (
                      <OverlayTrigger
                        overlay={<Tooltip id="tooltip">Leave Taken</Tooltip>}
                      >
                        <span className="d-inline-block leave-tooltip">
                          {day}
                        </span>
                      </OverlayTrigger>
                    );
                  } else {
                    return <span className="d-inline-block">{day}</span>;
                  }
                }
              }}
            />
          </Col>
          <Col className="col-md-8">
            <div className="overview-section">
              <Row className="text-center overviewSection">
                <div className="col-md-4 overviewCol">
                  <strong>Carry Forward Leaves</strong>
                  <div className="alert alert-primary" role="alert">
                    {/* {this.state.totalDaysInMonth} */}
                    {this.state.CarryForwardLeaves}
                  </div>
                </div>
                <div className="col-md-4 overviewCol">
                  <strong>Credit Leaves</strong>
                  <div className="alert alert-secondary" role="alert">
                    {this.state.Creditleaves}
                  </div>
                </div>
                <div className="col-md-4 overviewCol">
                  <strong>Total Leaves</strong>
                  <div className="alert alert-success" role="alert">
                    {this.state.TotalLeaves}
                    {/* {Number(this.state.CarryForwardLeaves || 0) +
                      Number(this.state.LeaveBalance || 0)} */}
                  </div>
                </div>
                <div className="col-md-4 overviewCol">
                  <strong>Used Leaves</strong>
                  <div className="alert alert-danger" role="alert">
                    {this.state.UsedLeaves}
                  </div>
                </div>
                <div className="col-md-4 overviewCol">
                  <strong>Balance Leaves</strong>
                  <div className="alert alert-warning" role="alert">
                    {this.state.LeaveBalance}
                  </div>
                </div>
                <div className="col-md-4 overviewCol">
                  <strong>Total Loss Of Pay</strong>
                  <div className="alert alert-info" role="alert">
                    {this.state.LosofpayLeaves}
                  </div>
                </div>
                <div className="col-md-4 overviewCol">
                  <strong>Comp Off Leaves</strong>
                  <div
                    className="alert"
                    role="alert"
                    style={{
                      backgroundColor: "#d3ff21",
                      color: "#000",
                      borderColor: "#d2b4de",
                    }}
                  >
                    {this.state.CompoffLeaves}
                  </div>
                </div>
              </Row>
            </div>
          </Col>
        </div>
        <div className="row my-3">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div
              id="datatable_wrapper"
              className="dataTables_wrapper form-inline
                  dt-bootstrap no-footer"
            >
              <Row className="row">
                <Col>
                  {/* New Leave Request Offcanvas */}
                  <Offcanvas
                    show={this.state.show}
                    onHide={this.handleOffcanvasClose}
                    {...this.props}
                    style={{ width: "500px" }}
                    placement="end"
                    backdrop="true"
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>New Leave Request</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <Container style={{ height: "auto" }}>
                        <Row className="divstyle">
                          <Row>
                            <Form>
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Requested By
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    {uName}
                                  </Form.Label>
                                </Col>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {" "}
                                  {this.state.errors.RequestedBy}{" "}
                                </div>
                              </Row>
                              <br />
                              <Row className="mb-3">
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Available Leaves
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    {this.state.LeaveBalance}
                                  </Form.Label>
                                </Col>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {" "}
                                  {this.state.errors.LeaveBalance}{" "}
                                </div>
                              </Row>
                              <br />
                              <Row className="mb-3">
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    From Date
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <DatePicker
                                    name="FromDate"
                                    //onChange={this.handledobChange}
                                    dateFormat="dd/MM/yyyy"
                                    showTimeSelect={false}
                                    selected={this.state.FromDate}
                                    // onChange={(date) =>
                                    //   this.handleDChange(date)
                                    // }
                                    onChange={this.handleFromDateChange}
                                    className="form-control"
                                    id="FromDate"
                                    placeholderText="Select Current Date"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    // minDate={previousYearStart}
                                    dropdownMode="select"
                                    minDate={minDate}
                                    //maxDate={new Date()}
                                    dayClassName={(date) => {
                                      const y = date.getFullYear();
                                      const m = String(
                                        date.getMonth() + 1,
                                      ).padStart(2, "0");
                                      const d = String(date.getDate()).padStart(
                                        2,
                                        "0",
                                      );
                                      const formattedDate = `${y}-${m}-${d}`;
                                      const dayOfWeek = date.getDay(); // 0 = Sun, 6 = Sat
                                      // --- API holidays ---
                                      const isHoliday =
                                        this.state.Holidays?.some(
                                          (h) => h.Date === formattedDate,
                                        );

                                      // --- Leaves (approved only) ---
                                      const isLeave = this.state.data?.some(
                                        (lv) =>
                                          lv.recordType !== "cancellation" &&
                                          lv.Decision === "Approved" &&
                                          lv.FromDate <= formattedDate &&
                                          lv.ToDate >= formattedDate &&
                                          !this.isDateCancelledForLeave(
                                            lv.leaverequestapprovals_Id,
                                            formattedDate,
                                          ),
                                      );
                                      if (isHoliday) return "holidayleave";
                                      if (isLeave) return "leave-datesleave";
                                      // --- Sundays always holidays ---
                                      if (dayOfWeek === 0)
                                        return "holidayleave";
                                      // --- Saturdays rule only if NOT leave/holiday ---
                                      if (dayOfWeek === 6) {
                                        const year = date.getFullYear();
                                        const month = date.getMonth();
                                        const saturdays = [];
                                        let tmp = new Date(year, month, 1);
                                        while (tmp.getMonth() === month) {
                                          if (tmp.getDay() === 6)
                                            saturdays.push(tmp.getDate());
                                          tmp.setDate(tmp.getDate() + 1);
                                        }
                                        const total = saturdays.length;
                                        const day = date.getDate();

                                        if (total === 5) {
                                          return [
                                            saturdays[0],
                                            saturdays[1],
                                            saturdays[2],
                                          ].includes(day)
                                            ? "holidayleave"
                                            : "normal-saturday";
                                        }
                                        if (total === 4) {
                                          return [
                                            saturdays[0],
                                            saturdays[1],
                                          ].includes(day)
                                            ? "holidayleave"
                                            : "normal-saturday";
                                        }
                                      }
                                      return undefined;
                                    }}
                                  />
                                </Col>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {" "}
                                  {this.state.errors.FromDate}{" "}
                                </div>
                              </Row>
                              <br />
                              <Row className="mb-3">
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    To Date
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <DatePicker
                                    name="ToDate"
                                    dateFormat="dd/MM/yyyy"
                                    showTimeSelect={false}
                                    selected={this.state.ToDate}
                                    // onChange={(date) =>
                                    //   this.handleDOJChange(date)
                                    // }
                                    onChange={this.handleToDateChange}
                                    className="form-control"
                                    id="ToDate"
                                    placeholderText="Select Date"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    //minDate={previousYearStart}
                                    dropdownMode="select"
                                    minDate={this.state.FromDate}
                                    disabled={
                                      this.state.LeaveType ===
                                      "Compensatory Leave"
                                    }
                                    //maxDate={new Date()}
                                    dayClassName={(date) => {
                                      const y = date.getFullYear();
                                      const m = String(
                                        date.getMonth() + 1,
                                      ).padStart(2, "0");
                                      const d = String(date.getDate()).padStart(
                                        2,
                                        "0",
                                      );
                                      const formattedDate = `${y}-${m}-${d}`;
                                      const dayOfWeek = date.getDay(); // 0 = Sun, 6 = Sat
                                      // --- API holidays ---
                                      const isHoliday =
                                        this.state.Holidays?.some(
                                          (h) => h.Date === formattedDate,
                                        );

                                      // --- Leaves (approved only) ---
                                      const isLeave = this.state.data?.some(
                                        (lv) =>
                                          lv.recordType !== "cancellation" &&
                                          lv.Decision === "Approved" &&
                                          lv.FromDate <= formattedDate &&
                                          lv.ToDate >= formattedDate &&
                                          !this.isDateCancelledForLeave(
                                            lv.leaverequestapprovals_Id,
                                            formattedDate,
                                          ),
                                      );
                                      if (isHoliday) return "holidayleave";
                                      if (isLeave) return "leave-datesleave";
                                      // --- Sundays always holidays ---
                                      if (dayOfWeek === 0)
                                        return "holidayleave";
                                      // --- Saturdays rule only if NOT leave/holiday ---
                                      if (dayOfWeek === 6) {
                                        const year = date.getFullYear();
                                        const month = date.getMonth();
                                        const saturdays = [];
                                        let tmp = new Date(year, month, 1);
                                        while (tmp.getMonth() === month) {
                                          if (tmp.getDay() === 6)
                                            saturdays.push(tmp.getDate());
                                          tmp.setDate(tmp.getDate() + 1);
                                        }
                                        const total = saturdays.length;
                                        const day = date.getDate();

                                        if (total === 5) {
                                          return [
                                            saturdays[0],
                                            saturdays[1],
                                            saturdays[2],
                                          ].includes(day)
                                            ? "holidayleave"
                                            : "normal-saturday";
                                        }
                                        if (total === 4) {
                                          return [
                                            saturdays[0],
                                            saturdays[1],
                                          ].includes(day)
                                            ? "holidayleave"
                                            : "normal-saturday";
                                        }
                                      }
                                      return undefined;
                                    }}
                                  />
                                </Col>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {" "}
                                  {this.state.errors.ToDate}{" "}
                                </div>
                              </Row>
                              <br />
                              <Row className="mb-3">
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    No. of Leaves
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    type="number"
                                    onChange={this.handleNoOfLeavesChange}
                                    className="form-control"
                                    name="NoOfLeaves"
                                    value={this.state.NoOfLeaves}
                                    required="required"
                                    placeholder="Enter NoOfLeaves"
                                    readOnly
                                    disabled
                                  />
                                </Col>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {" "}
                                  {this.state.errors.NoOfLeaves}{" "}
                                </div>
                              </Row>
                              <br />
                              <Row className="mb-3">
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Leave Type
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <select
                                    className="form-select"
                                    name="LeaveType"
                                    value={this.state.LeaveType}
                                    style={{ borderRadius: "0px" }}
                                    onChange={this.handleLeaveTypeChange}
                                  >
                                    <option disabled value="">
                                      Select leave Type
                                    </option>
                                    {this.state.leavetypes.map(
                                      (api, index, idx) => (
                                        <option
                                          key={index}
                                          value={api.LeaveType}
                                        >
                                          {" "}
                                          {api.LeaveType}{" "}
                                        </option>
                                      ),
                                    )}
                                  </select>
                                </Col>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {" "}
                                  {this.state.errors.LeaveType}{" "}
                                </div>
                              </Row>

                              {this.state.LeaveType ===
                                "Compensatory Leave" && (
                                <>
                                  <Row className="mb-3">
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Compensatory
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <DatePicker
                                        name="compensatoryDate"
                                        dateFormat="dd/MM/yyyy"
                                        showTimeSelect={false}
                                        selected={
                                          this.state.compensatoryDate
                                            ? new Date(
                                                this.state.compensatoryDate,
                                              )
                                            : null
                                        }
                                        onChange={
                                          this.handleCompensatoryDateChange
                                        }
                                        className="form-control"
                                        placeholderText="Select CompensatoryDate"
                                        maxDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        filterDate={(date) => {
                                          const y = date.getFullYear();
                                          const m = String(
                                            date.getMonth() + 1,
                                          ).padStart(2, "0");
                                          const d = String(
                                            date.getDate(),
                                          ).padStart(2, "0");
                                          const fDate = `${y}-${m}-${d}`;
                                          // Exclude already used compensatory dates
                                          if (
                                            this.state.usedCompensatoryDates.includes(
                                              fDate,
                                            )
                                          )
                                            return false;
                                          // Allow any past date
                                          return true;
                                        }}
                                        dayClassName={(date) => {
                                          const y = date.getFullYear();
                                          const m = String(
                                            date.getMonth() + 1,
                                          ).padStart(2, "0");
                                          const d = String(
                                            date.getDate(),
                                          ).padStart(2, "0");
                                          const fDate = `${y}-${m}-${d}`;
                                          if (
                                            this.state.usedCompensatoryDates.includes(
                                              fDate,
                                            )
                                          ) {
                                            return "compensatory-used-date";
                                          }
                                          if (
                                            this.state.Holidays.some(
                                              (h) => h.Date === fDate,
                                            )
                                          ) {
                                            return "holidayleave";
                                          }
                                          if (date.getDay() === 0) {
                                            return "holidayleave";
                                          }
                                          // --- Non-working Saturdays ---
                                          if (date.getDay() === 6) {
                                            const year = date.getFullYear();
                                            const month = date.getMonth();
                                            const saturdays = [];
                                            let tmp = new Date(year, month, 1);
                                            while (tmp.getMonth() === month) {
                                              if (tmp.getDay() === 6)
                                                saturdays.push(tmp.getDate());
                                              tmp.setDate(tmp.getDate() + 1);
                                            }
                                            const total = saturdays.length;
                                            const day = date.getDate();
                                            if (total === 5) {
                                              return [
                                                saturdays[0],
                                                saturdays[1],
                                                saturdays[2],
                                              ].includes(day)
                                                ? "holidayleave"
                                                : "normal-saturday";
                                            }
                                            if (total === 4) {
                                              return [
                                                saturdays[0],
                                                saturdays[1],
                                              ].includes(day)
                                                ? "holidayleave"
                                                : "normal-saturday";
                                            }
                                          }
                                          return undefined;
                                        }}
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {this.state.errors.compensatoryDate}
                                    </div>
                                  </Row>
                                </>
                              )}
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Reason
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    as="textarea"
                                    onChange={this.handleDecisionChange}
                                    className="form-control"
                                    name="remarks"
                                    value={this.state.remarks}
                                    required="required"
                                    placeholder="Enter Remarks"
                                    rows={3}
                                  />
                                </Col>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {" "}
                                  {this.state.errors.remarks}{" "}
                                </div>
                              </Row>
                            </Form>
                          </Row>
                        </Row>
                        <Row>
                          <Col
                            className="d-flex justify-content-end"
                            style={{ marginRight: "20px" }}
                          >
                            <Button
                              className="button"
                              variant="success"
                              onClick={this.LeaverequestapprovalssubmitHandler}
                              disabled={this.state.isSubmitting}
                              style={{
                                marginTop: "20px",
                              }}
                            >
                              {this.state.isSubmitting
                                ? "Submitting..."
                                : "Submit"}
                            </Button>
                          </Col>
                        </Row>
                      </Container>
                    </Offcanvas.Body>
                  </Offcanvas>
                  {/*offcanvas is over */}

                  {/* Leave Cancel Request OffcanvasShow */}
                  <Offcanvas
                    show={this.state.lCRshow}
                    onHide={this.LeaveCancelRequesthandleOffcanvasClose}
                    {...this.props}
                    style={{ width: "500px" }}
                    placement="end"
                    backdrop="true"
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>
                        Leave Cancel Request / Edit Applied Leave's
                      </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <Container style={{ height: "auto" }}>
                        <Row>
                          <Form.Label className="mb-1">
                            <strong>Select Leave to Cancel</strong>
                          </Form.Label>
                          <Form.Select
                            name="leaverequest"
                            value={this.state.leaverequest}
                            className="form-control"
                            id="leaverequest"
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              this.setState({
                                leaverequest: selectedId,
                                cancelDates: [],
                                cancellationReason: "",
                              });

                              const record = this.state.data.find(
                                (lv) =>
                                  // eslint-disable-next-line
                                  lv.leaverequestapprovals_Id == selectedId,
                              );

                              if (record) {
                                // Auto-select all cancellable (today & upcoming) dates
                                const allDates = this.getLeaveDates(
                                  record.FromDate,
                                  record.ToDate,
                                );
                                const cancellableDates = allDates.filter((d) =>
                                  this.isDateCancellable(d),
                                );
                                this.setState({
                                  fName: record.RequestedBy,
                                  leaves: record.LeaveBalance,
                                  FromDate: record.FromDate,
                                  ToDate: record.ToDate,
                                  NoOfLeaves: record.NoOfLeaves,
                                  LeaveType: record.LeaveType,
                                  remarks: record.remarks,
                                  approverName: record.approverName,
                                  Decision: record.Decision,
                                  DecisionRemarks: record.DecisionRemarks,
                                  leaverequestapprovals_Id:
                                    record.leaverequestapprovals_Id,
                                  cancelDates: cancellableDates,
                                });
                              } else {
                                this.setState({
                                  fName: "",
                                  leaves: "",
                                  FromDate: "",
                                  ToDate: "",
                                  NoOfLeaves: "",
                                  LeaveType: "",
                                  remarks: "",
                                  approverName: "",
                                  Decision: "",
                                  DecisionRemarks: "",
                                  leaverequestapprovals_Id: "",
                                  cancelDates: [],
                                  cancellationReason: "",
                                });
                              }
                            }}
                          >
                            <option value="">Select Leave to Cancel</option>
                            {(() => {
                              const now = new Date();
                              now.setHours(0, 0, 0, 0);
                              const thirtyDaysAgo = new Date(now);
                              thirtyDaysAgo.setDate(
                                thirtyDaysAgo.getDate() - 30,
                              );
                              // Build a set of parent IDs that already have a pending cancellation (status=5) or approved-cancel (status=6)
                              const blockedParentIds = new Set(
                                this.state.data
                                  .filter(
                                    (r) =>
                                      r.recordType === "cancellation" &&
                                      // eslint-disable-next-line
                                      (r.status == 5 || r.status == 6) &&
                                      r.parentLeaveId,
                                  )
                                  .map((r) => String(r.parentLeaveId)),
                              );
                              return this.state.data
                                .filter((lv) => {
                                  // Only show original Approved (2) leave rows, not cancellation rows
                                  if (lv.recordType === "cancellation")
                                    return false;
                                  // eslint-disable-next-line
                                  if (lv.status != 2) return false;
                                  // Exclude leaves that already have a pending / approved cancellation
                                  if (
                                    blockedParentIds.has(
                                      String(lv.leaverequestapprovals_Id),
                                    )
                                  )
                                    return false;
                                  // Exclude leaves where ToDate is more than 30 days ago
                                  const to = new Date(lv.ToDate);
                                  to.setHours(0, 0, 0, 0);
                                  return to >= thirtyDaysAgo;
                                })
                                .sort(
                                  (a, b) =>
                                    new Date(b.FromDate) - new Date(a.FromDate),
                                )
                                .map((lv, index) => {
                                  const lopInfo =
                                    lv.lopDays > 0
                                      ? ` (${lv.lopDays} LOP)`
                                      : "";
                                  return (
                                    <option
                                      key={index}
                                      value={lv.leaverequestapprovals_Id}
                                    >
                                      {window.formatDate(lv.FromDate)} -{" "}
                                      {window.formatDate(lv.ToDate)} |{" "}
                                      {lv.LeaveType} | {lv.NoOfLeaves} Day(s)
                                      {lopInfo} | Approved
                                    </option>
                                  );
                                });
                            })()}
                          </Form.Select>
                        </Row>
                        {this.state.leaverequest && (
                          <>
                            <Row className="mt-2">
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Requested By
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="text"
                                  value={this.state.fName}
                                  disabled
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  From Date
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="date"
                                  value={this.state.FromDate}
                                  disabled
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  To Date
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="date"
                                  value={this.state.ToDate}
                                  disabled
                                />
                              </Col>
                            </Row>
                            <Row className="mb-3">
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Leave Type
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="text"
                                  value={this.state.LeaveType}
                                  disabled
                                />
                              </Col>
                            </Row>

                            {/* Date checkboxes for partial cancellation */}
                            {(() => {
                              const allDates = this.getLeaveDates(
                                this.state.FromDate,
                                this.state.ToDate,
                              );
                              const cancellableDates = allDates.filter((d) =>
                                this.isDateCancellable(d),
                              );
                              const allSelected =
                                cancellableDates.length > 0 &&
                                cancellableDates.every((d) =>
                                  this.state.cancelDates.includes(d),
                                );
                              return (
                                <Row className="mb-3">
                                  <Col md="12">
                                    <Form.Label>
                                      <strong>Select Dates to Cancel</strong>
                                    </Form.Label>
                                    {cancellableDates.length > 1 && (
                                      <Form.Check
                                        type="checkbox"
                                        label="Select All"
                                        checked={allSelected}
                                        onChange={() =>
                                          this.handleSelectAllCancelDates(
                                            cancellableDates,
                                          )
                                        }
                                        style={{
                                          marginBottom: "5px",
                                          fontWeight: "bold",
                                        }}
                                      />
                                    )}
                                    <div
                                      style={{
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        border: "1px solid #dee2e6",
                                        borderRadius: "4px",
                                        padding: "8px",
                                      }}
                                    >
                                      {allDates.map((dateStr, idx) => {
                                        const isCancellable =
                                          this.isDateCancellable(dateStr);
                                        const dateObj = new Date(dateStr);
                                        const dayName =
                                          dateObj.toLocaleDateString("en-US", {
                                            weekday: "short",
                                          });
                                        const displayDate =
                                          window.formatDate(dateStr);
                                        return (
                                          <Form.Check
                                            key={idx}
                                            type="checkbox"
                                            label={
                                              <span
                                                style={{
                                                  color: isCancellable
                                                    ? "#000"
                                                    : "#999",
                                                  textDecoration: isCancellable
                                                    ? "none"
                                                    : "line-through",
                                                }}
                                              >
                                                {displayDate} ({dayName})
                                                {!isCancellable && (
                                                  <small
                                                    style={{
                                                      color: "#dc3545",
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    (Past)
                                                  </small>
                                                )}
                                              </span>
                                            }
                                            checked={this.state.cancelDates.includes(
                                              dateStr,
                                            )}
                                            disabled={!isCancellable}
                                            onChange={() =>
                                              this.handleCancelDateToggle(
                                                dateStr,
                                              )
                                            }
                                            style={{ marginBottom: "3px" }}
                                          />
                                        );
                                      })}
                                    </div>
                                    <small className="text-muted mt-1 d-block">
                                      {this.state.cancelDates.length} date(s)
                                      selected for cancellation
                                    </small>
                                  </Col>
                                </Row>
                              );
                            })()}

                            <Row className="mb-3">
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Remarks
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  type="text"
                                  value={this.state.remarks}
                                  disabled
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col lg="4" md="4">
                                <Form.Label style={{ paddingTop: "8px" }}>
                                  Cancellation Reason
                                </Form.Label>
                              </Col>
                              <Col lg="8" md="8">
                                <Form.Control
                                  as="textarea"
                                  rows={2}
                                  name="cancellationReason"
                                  value={this.state.cancellationReason}
                                  onChange={(e) =>
                                    this.setState({
                                      cancellationReason: e.target.value,
                                    })
                                  }
                                  placeholder="Enter Leave Cancel Request Explanation"
                                />
                              </Col>
                            </Row>

                            <Row className="mb-3">
                              <Col className="d-flex justify-content-end">
                                <Button
                                  className="button rounded-0"
                                  variant="warning"
                                  onClick={
                                    this.LeaverequestcancelrequestsubmitHandler
                                  }
                                  disabled={this.state.isCancelRequesting}
                                >
                                  {this.state.isCancelRequesting
                                    ? "Requesting..."
                                    : "Cancel Leave Request"}
                                </Button>
                              </Col>
                            </Row>
                          </>
                        )}
                      </Container>
                    </Offcanvas.Body>
                  </Offcanvas>

                  {/* Leave Cancel Approval OffcanvasShow */}
                  <Offcanvas
                    show={this.state.lCAshow}
                    onHide={this.LeaveCancelApprovalhandleOffcanvasClose}
                    {...this.props}
                    style={{ width: "500px" }}
                    placement="end"
                    backdrop="true"
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>Leave Cancel Approval</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <Container style={{ height: "auto" }}>
                        <Row className="divstyle">
                          <Row>
                            <Form>
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Requested By
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    <b> {uName}</b>
                                  </Form.Label>
                                </Col>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {" "}
                                  {this.state.errors.RequestedBy}{" "}
                                </div>
                              </Row>
                              <br />

                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    From Date
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <DatePicker
                                    name="FromDate"
                                    //onChange={this.handledobChange}
                                    dateFormat="dd/MM/yyyy"
                                    showTimeSelect={false}
                                    selected={this.state.FromDate}
                                    // onChange={(date) =>
                                    //   this.handleDChange(date)
                                    // }
                                    onChange={this.handleFromDateChange}
                                    className="form-control"
                                    id="FromDate"
                                    placeholderText="Select Current Date"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    // minDate={previousYearStart}

                                    dropdownMode="select"
                                    minDate={minDate}
                                    //maxDate={new Date()}
                                  />
                                </Col>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {" "}
                                  {this.state.errors.FromDate}{" "}
                                </div>
                              </Row>
                              <br />
                              <Row className="mb-3">
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    To Date
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <DatePicker
                                    name="ToDate"
                                    dateFormat="dd/MM/yyyy"
                                    showTimeSelect={false}
                                    selected={this.state.ToDate}
                                    // onChange={(date) =>
                                    //   this.handleDOJChange(date)
                                    // }
                                    onChange={this.handleToDateChange}
                                    className="form-control"
                                    id="ToDate"
                                    placeholderText="Select Date"
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    //minDate={previousYearStart}
                                    dropdownMode="select"
                                    minDate={this.state.FromDate}
                                    //maxDate={new Date()}
                                  />
                                </Col>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {" "}
                                  {this.state.errors.ToDate}{" "}
                                </div>
                              </Row>
                              <br />
                              <Row className="mb-3">
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    No. of Leaves
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    type="number"
                                    onChange={this.handleNoOfLeavesChange}
                                    className="form-control"
                                    name="NoOfLeaves"
                                    value={this.state.NoOfLeaves}
                                    required="required"
                                    placeholder="Enter NoOfLeaves"
                                    readOnly
                                    disabled
                                  />
                                </Col>
                                <div
                                  className="errorMsg"
                                  style={{ color: "red" }}
                                >
                                  {" "}
                                  {this.state.errors.NoOfLeaves}{" "}
                                </div>
                              </Row>
                              <br />

                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Leave Cancelation Explanation
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    as="textarea"
                                    rows={3}
                                    onChange={this.handlelcdetailsChange}
                                    name="lcdetails"
                                    placeholder="Enter Leave Cancelation Explanation"
                                    value={this.state.lcdetails}
                                    className="form-control"
                                  />
                                </Col>
                              </Row>

                              <br />
                            </Form>
                          </Row>
                        </Row>
                        <Row>
                          <Col
                            className="d-flex justify-content-end"
                            style={{ marginRight: "50px" }}
                          >
                            <Button
                              className="button rounded-0"
                              variant="warning"
                              onClick={this.LeaverequestapprovalssubmitHandler}
                              disabled={this.state.isSubmitting}
                              style={{
                                marginTop: "20px",
                              }}
                            >
                              {this.state.isSubmitting
                                ? "Processing..."
                                : "Approve Leave Cancel Request"}
                            </Button>
                          </Col>
                        </Row>
                      </Container>
                    </Offcanvas.Body>
                  </Offcanvas>
                </Col>
              </Row>
              <Row className="py-3 ">
                <div className="col-md-6 ">
                  <div className="widget_BG d-flex align-items-center">
                    <h3 className="align-middle">Previous Leave Requests</h3>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="widget_BG text-end">
                    <input
                      type="text"
                      onChange={this.handleFilter}
                      placeholder="Search..."
                      className="form-control"
                    />
                  </div>
                </div>
              </Row>

              {/* Table 1: Leave Requests (original leaves — approved, rejected, pending, withdrawn) */}
              <Row>
                <div className="col-md-12">
                  <DataTable
                    data={paginatedData}
                    columns={this.leaveTableColumns()}
                    pagination
                    paginationTotalRows={leaveRows.length}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    onChangePage={this.handlePageChange}
                    paginationRowsPerPageOptions={[
                      100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
                    ]}
                    paginationPerPage={100}
                    keyField="leaverequestapprovals_Id"
                    noDataComponent={
                      <p style={{ padding: "20px", color: "#6c757d" }}>
                        No leave requests yet.
                      </p>
                    }
                    className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                  />
                </div>
              </Row>

              {/* Table 2: Leave Cancellation Requests (cancel events — pending, approved, rejected) */}
              <Row className="py-3 mt-4">
                <div className="col-md-12">
                  <div className="widget_BG d-flex align-items-center">
                    <h3 className="align-middle">
                      Leave Cancellation Requests
                    </h3>
                    {cancellationRows.length > 0 && (
                      <span
                        style={{
                          marginLeft: "12px",
                          fontSize: "14px",
                          background: "#fd7e14",
                          color: "#fff",
                          padding: "2px 10px",
                          borderRadius: "12px",
                        }}
                      >
                        {cancellationRows.length}
                      </span>
                    )}
                  </div>
                </div>
              </Row>
              <Row>
                <div className="col-md-12">
                  <DataTable
                    data={paginatedCancellations}
                    columns={this.cancellationTableColumns()}
                    pagination
                    paginationTotalRows={cancellationRows.length}
                    paginationRowsPerPageOptions={[
                      100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
                    ]}
                    paginationPerPage={100}
                    keyField="leaverequestapprovals_Id"
                    noDataComponent={
                      <p style={{ padding: "20px", color: "#6c757d" }}>
                        No cancellation requests yet.
                      </p>
                    }
                    className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                  />
                </div>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
